import React from 'react';
import { Card, Form, InputGroup } from 'react-bootstrap';
import { FaPhone, FaUser, FaUserCheck } from 'react-icons/fa';

const ContactSelector = ({ label, contact, onSelect, accountContact }) => {
  const contactValue = contact || { name: '', phone: '' };
  const canUseAccount = Boolean(accountContact?.name && accountContact?.phone);

  const handleFieldChange = (field, value) => {
    onSelect({
      ...contactValue,
      [field]: value,
      source: 'manual',
    });
  };

  const handleUseAccount = () => {
    if (!canUseAccount) {
      return;
    }

    onSelect({
      name: accountContact.name,
      phone: accountContact.phone,
      source: 'account',
    });
  };

  return (
    <Card className="contact-entry-card h-100">
      <Card.Body>
        <div className="contact-entry-header">
          <div>
            <span className="contact-entry-kicker">{label}</span>
            <strong>{contactValue.source === 'account' ? 'Using your account details' : 'Enter contact details directly'}</strong>
          </div>
        </div>

        <label className={`contact-account-option ${contactValue.source === 'account' ? 'is-selected' : ''}`}>
          <input
            type="checkbox"
            id={`${label.toLowerCase().replace(/\s+/g, '-')}-account-contact`}
            className="form-check-input contact-account-checkbox"
            checked={contactValue.source === 'account'}
            onChange={(event) => {
              if (event.target.checked) {
                handleUseAccount();
              } else {
                onSelect({
                  name: '',
                  phone: '',
                  source: 'manual',
                });
              }
            }}
            disabled={!canUseAccount}
          />
          <span className="contact-account-icon">
            <FaUserCheck />
          </span>
          <span className="contact-account-copy">
            <strong>Use my account</strong>
            <small>{canUseAccount ? 'Auto-fill name and phone number' : 'Account contact is unavailable'}</small>
          </span>
        </label>

        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <InputGroup>
            <InputGroup.Text className="contact-input-icon">
              <FaUser />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder={`Enter ${label.toLowerCase()} name`}
              value={contactValue.name || ''}
              onChange={(event) => handleFieldChange('name', event.target.value)}
            />
          </InputGroup>
        </Form.Group>

        <Form.Group>
          <Form.Label>Phone Number</Form.Label>
          <InputGroup>
            <InputGroup.Text className="contact-input-icon">+91</InputGroup.Text>
            <Form.Control
              type="tel"
              placeholder="Enter 10-digit phone number"
              value={contactValue.phone || ''}
              onChange={(event) => handleFieldChange('phone', event.target.value.replace(/\D/g, '').slice(0, 10))}
              maxLength={10}
            />
            <InputGroup.Text className="contact-input-icon">
              <FaPhone />
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default ContactSelector;
